const WarehouseMGroup = `
  mgroup
`;

export default WarehouseMGroup;
